import React, { useState, useEffect } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import OfflineDb from '../../db'
import { useTranslation } from 'react-i18next';
import swal from 'sweetalert'
import {useHistory} from "react-router-dom";
import { useGlobalSpinnerActionsContext } from '../../context/GlobalSpinnerContext'
import { apiServices } from '../../services/apiServices';

function SurveyListing() {

    return (
        <> </>
    )
}

export default SurveyListing